import QrLandingPageActionTypes from './qr-landing-page-action-types';
import ValidationError from '../../../utils/validation-error';

export const scanQrToken = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: QrLandingPageActionTypes.SCAN_QR_TOKEN_START });
  try {
    const result = await api.post('api/general_competency_hours/scan', { token: payload.token });
    dispatch({
      type: QrLandingPageActionTypes.SCAN_QR_TOKEN_END,
      payload: { result }
    });
  } catch (error) {
    let errorMessage = null;
    if (error instanceof ValidationError) {
      errorMessage = error.message;
    }
    dispatch({
      type: QrLandingPageActionTypes.SCAN_QR_TOKEN_END,
      payload: { errorMessage }
    });
  }
};
